import { Component } from 'react';
import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import Small from 'UIComponents/elements/Small';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledSmall = styled(Small).withConfig({
  displayName: "BinaryField__StyledSmall",
  componentId: "nop5fi-0"
})(["font-style:italic;"]);
export default class BinaryField extends Component {
  render() {
    /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
    const {
      schema
    } = this.props;
    return /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(StyledSmall, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `developer-docs-shared-components.params.errors.fileType.${schema.format}`
        })
      })
    });
  }
}